export default __webpack_public_path__ + "static/media/phys.714945f3.png";